export const goTo = (page) => {
  let parts = String(document.URL).split('/')
  if (parts.length > 1) parts.pop()
  window.location.replace(`${parts.join('/')}/${page}`);
}